module.exports = __webpack_public_path__ + "img/banklogo.c9f3a1d9.png";